import ListingVM from './listing-vm';

export default {
  init() {
    const jsonValue = document.getElementById('students_json').value
    const studentsData = JSON.parse(jsonValue)

    ko.applyBindings(
      new ListingVM(studentsData),
      document.getElementById('student_listing')
    );
  }
};

